import { permissionSystem } from '@arc/shared/util-permissions';
import { minPatchPrimitive, minPatchRecord } from '@arc/shared/util-superstruct';
export const minPatchEditPermissionsDto = minPatchRecord(permissionSystem.permissionTypes, minPatchRecord(permissionSystem.actionTypes, minPatchPrimitive));